import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { DataGridPaper } from 'components/Ui/styled';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';
import { getAssetNotesDataGrid } from './AssetNotesDataGrid';

const AssetNotes = ({ row: rowProp }) => {
  const { assetNotes = [] } = rowProp || {};

  const columns = [
    {
      headerName: 'Date',
      field: 'date',
      type: 'date',
      width: 120,
    },
    {
      headerName: 'Asset Note',
      field: 'note',
      flex: 1,
      renderCell: renderCellExpand,
    },
  ];

  return (
    <Stack sx={{ py: 2 }} direction='column'>
      <DataGridPaper>
        <Stack direction='column' spacing={1}>
          {getAssetNotesDataGrid(columns, assetNotes)}
        </Stack>
      </DataGridPaper>
    </Stack>
  );
};

AssetNotes.propTypes = {
  row: PropTypes.object.isRequired,
};

export default AssetNotes;
